import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const ShoppingBag_2: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			rotate: 0,
		},
		config: {
			duration: 800,
		},
		onRest: (_, spring) => spring.set({ rotate: 0 }),
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ rotate: 360 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path d="M314.13 320.05a5.11 5.11 0 01-.65-1.71c.29.8.52 1.41.65 1.71z" />
				<path d="M337.19 331.4l-12.46-20.68c-2.81-9.77-11.69-149.5-13.55-179.26s0-.31 0-.45V118a4.51 4.51 0 00-4.6-4.41h-25.9l-10.29-4.22h-.09a4.92 4.92 0 00-1.72-.33h-5.08l-144.22 7.94h-.31l-4.83.23a4.5 4.5 0 00-4.37 4.62S99.1 320.49 98.89 328.05s5.73 8.32 5.73 8.32l159.47 38.35a3.68 3.68 0 002.44-.39L326.7 341l.05.08 9.13-5.06a3.31 3.31 0 001.31-4.62zM297 127.34l.43 3.63a1 1 0 000 .11v.44c.76 10.47 12.16 167.9 12.16 172.49 0 3.55 2.58 10.85 3.89 14.31.29.81.54 1.41.65 1.72a.36.36 0 010 .11v.07l1.51 2.5-22.35-7.21-3.15-188.22zm-31.23 221.12l7.4-222v-2.22l7.92 3.25 3.18 190.27zm4.12 7.84l20.46-33.95 25.83 8.33z" />
				<path d="M191.24 116.05s-8.42-63.39 20.3-73.35c.39.2 22.59 6.34 13.38 71.47" />
				<path d="M271 115.81s-1.43-86-59.43-73.11c0 0-53.39-18.16-58 78.13" />
			</svg>
		</animated.span>
	)
}

export { ShoppingBag_2 }
